import { PreprocessingTaskStatus } from '@/api';
import type { VaultItem } from '@/stores/vaultStore';

export const supportedArchives = [
  ['application/zip', '.zip'],
  ['message/rfc822', '.eml'],
];

export function isArchive(contentType: string | undefined, fileName: string): boolean {
  return supportedArchives.some(
    ([mime, ext]) => contentType === mime || fileName.toLowerCase().endsWith(ext)
  );
}

export function isPdfVaultFile(row: VaultItem): boolean {
  return row.type === 'file' && isPdfFile(row.contentType, row.name);
}

export function isConversionInProgress(row: VaultItem): boolean {
  return isConversionRunning(row.conversionStatus);
}

/** A PDF by type or name — what "Convert to DOCX" applies to. */
export function isPdfFile(contentType: string | null | undefined, fileName: string): boolean {
  return contentType === 'application/pdf' || /\.pdf$/i.test(fileName);
}

/** A revision's DOCX conversion is queued or running. */
export function isConversionRunning(status: PreprocessingTaskStatus | null | undefined): boolean {
  return status === PreprocessingTaskStatus.PENDING || status === PreprocessingTaskStatus.RUNNING;
}
